import {
  Metric,
  MetricStrip,
} from '../../../../../components/shared/metric-strip/MetricStrip';
import { BaseComponentProps } from '../../../../../types/base-component.types';
import { formatFromSeconds } from '../../../../../utils/date';
import { formatGrade } from '../../../../../utils/numbers';
import { AssessmentMetricsViewModel } from '../../../api/useMultipleChoiceAssessments';

type ContainerProps = BaseComponentProps & {
  metrics: AssessmentMetricsViewModel;
  /**
   * The assessment's own declared cut-off, which takes precedence over the computed
   * one — the same order the preview reads them in, so a simulacro shows one figure.
   */
  cutoffScore?: number;
};

function AssessmentMetrics({
  className,
  metrics,
  cutoffScore,
  testId = 'ui-assessment-metrics',
}: ContainerProps) {
  // The cut-off mark is the figure the board is read against, so it takes the
  // middle column with the averages on either side of it.
  //
  // All three are written even before anyone has finished, when they come back as
  // noughts: the strip keeps its columns whatever the board under it says, so a card
  // does not change shape the moment the first mark lands on it.
  const items: Metric[] = [
    { label: 'Nota media', value: formatGrade(metrics.averageGrade) },
    {
      label: 'Nota de corte',
      value: formatGrade(cutoffScore ?? metrics.cutoffScore),
    },
    {
      label: 'Tiempo medio',
      value: formatFromSeconds(metrics.averageTime),
    },
  ];

  return <MetricStrip className={className} metrics={items} testId={testId} />;
}

export { AssessmentMetrics };
